import { api } from ".";
import type { KyResponse } from "ky";

export type UserInfo = {
  id: string;
  full_name: string;
  email: string;
  is_verified: boolean;
  is_active: boolean;
  role_id: number;
  department_id: number;
  /** Date string */
  created_at: string;
  /** Date string */
  updated_at: null | string;

  /**
   * Mapping of resources to allowed actions.
   *
   * `all` means everything is allowed, be it all actions for a given resource or all resources
   */
  permissions: Record<string, Array<string>>;
};

function me(): Promise<KyResponse<UserInfo>> {
  return api.raw.get<UserInfo>("api/v1/auth/me");
}

function changePassword(props: { current: string; new: string }) {
  return api.raw.post("api/v1/auth/change-password", {
    json: {
      current_password: props.current,
      new_password: props.new,
    },
  });
}

function updatePassword(props: { token: string; password: string }) {
  return api.raw.post("api/v1/auth/update-password", {
    json: {
      token: props.token,
      new_password: props.password,
    },
  });
}

function forgotPassword(props: { email: string }) {
  return api.raw.post("api/v1/auth/forgot-password", {
    json: {
      email: props.email,
    },
  });
}

export default {
  me,
  changePassword,
  updatePassword,
  forgotPassword,
};
